import { LoseRuleProps } from 'modules/tournaments/ui/components/form-parts/rules/types';
import React, { ReactNode } from 'react';
import { LabeledInput, SectionTitle } from '../fields';

interface ExtendedLoseRuleProps extends LoseRuleProps {
  children?: ReactNode;
}

const LoseBase: React.FC<ExtendedLoseRuleProps> = ({ sportType = 'general', children }) => {
  return (
    <>
      <SectionTitle
        title="Поражение"
        icon="❌"
        tooltip="Настройка очков за поражение (обычно 0, но может меняться в особых форматах турниров)."
      />

      <LabeledInput
        name="settings.lossScore"
        placeholder="0 очков"
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip="Очки за проигрыш в основное время (обычно 0)."
        tooltipProps={{ position: 'input-right' }}
      />

      <LabeledInput
        name="settings.lossScoreExtraTime"
        placeholder="0 очков"
        label="В дополнительное время"
        tooltip="Очки за проигрыш в дополнительное время."
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default LoseBase;
